import styled from "styled-components";

export const FormBlock = styled.div`
  display: grid;
  gap: 14px;
  grid-template-columns: 1fr 1fr 1fr;
`;
